import dayjs from 'dayjs';
import preciseDiff from './preciseDiff';

const readbleDifference = (a = '', b = '') => {
  const x = a ? dayjs(parseInt(a, 10)) : dayjs();
  const y = b ? dayjs(parseInt(b, 10)) : dayjs();
  return preciseDiff(x, y, true);
};
const dateDiff = (time, countDownOrUp) => {
  if (countDownOrUp) return readbleDifference(time, ''); // should we count up
  return readbleDifference('', time); // or count down
};

export default dateDiff;
